import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Pages/Shared/Footer/Footer';
import Navbar from '../Pages/Shared/Navbar/Navbar';
import './Main.css'
import { Link, useLocation } from 'react-router-dom';
import GreenFooter from '../Pages/Shared/Footer/GreenFooter';

const Main = () => {
    const location = useLocation();
    const shouldHideLabel = location.pathname === "/";

    return (
        <div className="" >
            <Navbar></Navbar>
            <Outlet></Outlet>
            <GreenFooter></GreenFooter>
         </div>
    );
};

export default Main;